export const FooterLink = "atlantis-footer-link";
export const Footer = "atlantis-footer";
